import React, { useEffect, useState } from 'react';

export default function useFilterPillItemChopper(
  pillsLength: number,
  containerRef: React.RefObject<HTMLDivElement>
) {
  const [loaded, setLoaded] = useState(false);
  const [showMore, setShowMore] = useState(false);
  const [chopIndex, setChopIndex] = useState(pillsLength);

  useEffect(() => {
    setChopIndex(pillsLength);
  }, [pillsLength, showMore]);

  useEffect(() => {
    let isMounted = true;
    setTimeout(() => {
      if (isMounted) {
        setLoaded(false);
        const clientHeight = containerRef.current?.clientHeight;
        if (showMore) {
          // istanbul ignore else
          if (clientHeight <= 80) {
            setShowMore(false);
          }
          setLoaded(true);
        } else if (clientHeight > 56 && chopIndex > 0) {
          setChopIndex(chopIndex - 1);
        } else {
          setLoaded(true);
        }
      }
    }, 0);
    return () => {
      isMounted = false;
    };
  }, [chopIndex, showMore]);

  return {
    chopIndex,
    loaded,
    showMore,
    setShowMore,
  };
}
